<template>
  <div class="Switch-Btn" :class="get_activeClass" @click="toggleSwitch">
    <div class="Switch-Btn__dot"></div>
  </div>
</template>


<script setup>
  import { computed } from 'vue';
  import { Props } from './scripts/props';
  //-------------------------------------------
  const props = defineProps(Props());
  const emit = defineEmits(['update:isOn']);
  //-------------------------------------------
  //Добавление активного класса
  const get_activeClass = computed(() => props.isOn ? 'Switch-Btn--active' : '');
  //-------------------------------------------
  //Функция для переключения состояния
  const toggleSwitch = () => emit('update:isOn', !props.isOn);
</script>

<style scoped lang="scss">
  @import "./styles/style";
</style>
